import {mainQuery} from '@github-ui/react-core/future/main-query'
import {pullRequestsAppBuilder} from '../config/app-builder'
import type {OverviewRoutePayload, ActivityPayload} from './route-payload-types'
import type {ReviewRequestsData} from '../page-data/payloads/review-requests'
import type {AssigneesData} from '../page-data/payloads/assignees'
import {pageDataQuery} from './page-data-query'
import {isFeatureEnabled} from '@github-ui/feature-flags'

export const pullRequestsOverviewRoute = pullRequestsAppBuilder.createQueryRouteConfig('pullRequestsOverviewRoute', {
  path: '/:owner/:repo/pull/:pr_number/overview',
  queries: [
    mainQuery<OverviewRoutePayload>(),
    pageDataQuery<ReviewRequestsData, 'review_requests'>('review_requests', true),
    pageDataQuery<AssigneesData, 'assignees'>('assignees'),
    pageDataQuery<ActivityPayload, 'catch_up'>('catch_up', () => isFeatureEnabled('prs_overview_catch_up')),
  ],
})
